<template>
  <div >
    <div class="h60"></div>
    <div class="top fix" :class="{'bg':scroll || topActive !== 'industryStrategy'}">
      <div class="menuTab">
        <div class="logo" @click="jumpBack()">
          <img src="@/assets/images/strategy/logo.png" alt />
        </div>
        <div class="module">
          <template v-for="(item, ind) in menu">
          <div
            class="item"
            
            v-if="item.show"
            @click="topBtn(ind, item.path)"
            :class="{ active: topActive == item.path }"
            :key="ind"
          >

              {{ item.title }}

          </div>
        </template>
        </div>
        <div class="shop">
          <img class="icon" src="@/assets/images/shopTitle.png" width="20" height="20" />
          <div class="title">{{ this.$store.getters.loginUserInfo.shopTitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      topActive: "industryStrategy",
      menu: [
        {
          title: "行业运营策略",
          path: "industryStrategy",
          show: false,
        },
        {
          title: "行业破圈",
          path: "industrySolution",
          show: false,
        },
        {
          title: "行业人群",
          path: "industryCrowd",
          show: false,
        },
      ],
      scroll: false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    // this.scroll = true
    window.addEventListener('scroll', this.handleScroll)
    console.log(this.$route.path);
    if (this.$route.path == "/industryStrategy") {
      this.topActive = "industryStrategy";
    }
    if (this.$route.path == "/industrySolution") {
      this.topActive = "industrySolution";
    }
    if (this.$route.path == "/industryCrowd") {
      this.topActive = "industryCrowd";
    }
    const permission = JSON.parse(localStorage.getItem("permissionPath"));
    this.menu.map((item, index) => {
      if (permission.indexOf(item.path) != -1) {
        this.menu[index].show = true;
      } else {
        this.menu[index].show = false;
      }
      return;
    });
  },
  methods: {
    topBtn(type, path) {
      this.topActive = path;
      this.$router.push("/" + path);
      // window.open("/yusms/industryCrowd", "_blank")
    },
    jumpBack() {
      window.open("/yusms/home", "_blank");
    },
    handleScroll () {
      const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop) {
        this.scroll = true
      } else {
        this.scroll = false
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.h60{
  height: 60px;
}
.fix{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.bg{
  background-color: #6461e7;
}
.top {
  // background-color: #6461e7;

  .menuTab {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 auto;
    width: 1200px;

    .logo {
      width: 120px;
      height: 32px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .module {
      display: inline-block;
      height: 60px;
      .item {
        position: relative;
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin-left: 40px;
        cursor: pointer;
        height: 60px;
        opacity: 0.8;
      }
      .active {
        position: relative;
        font-weight: 400;
        opacity: 1;
      }
      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 0);
        width: 44px;
        height: 3px;
        background: #ffffff;
        border-radius: 4px;
      }
    }
    .shop{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: end;
      .icon{
        width: 20px;
        height: 20px;
      }
      .title{
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin-left: 4px;
      }
    }
  }
}
</style>
